import { fromJS } from 'immutable';

export default fromJS({
    partners: [],
});
